import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=32465bdf&scoped=true"
import script from "./NotificationsModal.vue?vue&type=script&lang=ts"
export * from "./NotificationsModal.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsModal.vue?vue&type=style&index=0&id=32465bdf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32465bdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32465bdf')) {
      api.createRecord('32465bdf', component.options)
    } else {
      api.reload('32465bdf', component.options)
    }
    module.hot.accept("./NotificationsModal.vue?vue&type=template&id=32465bdf&scoped=true", function () {
      api.rerender('32465bdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NotificationsModal.vue"
export default component.exports